import React, { useRef } from 'react'
import { useRecoilCallback, useRecoilValue, useResetRecoilState } from 'recoil'
import { useIntl } from 'react-intl'

import {
  Button,
  BUTTON_VARIANT_PRIMARY,
  BUTTON_VARIANT_SECONDARY,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead
} from 'mailup-web-components'
import { ColumnsManager } from './ColumnsManager'

import { modalColumnsManagementState } from 'Pages/AbTestWizard/recoil/state/modals'
import { modalColumnsManagementConfirmCallback } from 'Pages/AbTestWizard/recoil/callbacks/callbacks'

export const ModalColumnsManagement = () => {
  const intl = useIntl()

  const { show } = useRecoilValue(modalColumnsManagementState)
  const handleClose = useResetRecoilState(modalColumnsManagementState)

  const submit = useRecoilCallback(modalColumnsManagementConfirmCallback)

  const handleClickConfirm = () => {
    submit(columns.current)
  }

  const columns = useRef(null)

  return (
    <Modal show={show} onClose={handleClose}>
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.SearchRecipients.columnSettings'
        })}
      />
      <ModalBody>
        <React.Suspense fallback={() => null}>
          <ColumnsManager
            onChange={value => {
              columns.current = value
            }}
          />
        </React.Suspense>
      </ModalBody>
      <ModalFoot>
        <Button kind={BUTTON_VARIANT_SECONDARY} onClick={handleClose}>
          {intl.formatMessage({ id: 'Load.FormBuilder.BtnCancel' })}
        </Button>
        <Button kind={BUTTON_VARIANT_PRIMARY} onClick={handleClickConfirm}>
          {intl.formatMessage({ id: 'Load.SearchRecipients.Save' })}
        </Button>
      </ModalFoot>
    </Modal>
  )
}
